export default {
  buttons: {
    save: 'Salva',
  },
  error_messages: {
    product_unavailable: 'Esaurito!',
  },
};
